import ConfigurationRadio from './ConfigurationRadio'

export default ConfigurationRadio
